import { render, staticRenderFns } from "./PDA_Add.vue?vue&type=template&id=59e99836"
import script from "./PDA_Add.vue?vue&type=script&lang=js"
export * from "./PDA_Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports